<mat-form-field cdkFocusRegionstart [floatLabel]="floatPlaceholder">
  <input
    type="text"
    #input
    placeholder="{{ showLabel ? (label | translate) : '' }}"
    matInput
    [formControl]="inputControl"
    [matAutocomplete]="auto"
    (keydown.enter)="acceptChoice()"
    (input)="valueChanged($event.target.value)"
  />
</mat-form-field>
<mat-autocomplete (optionSelected)="setSelected($event.option.value)" #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
  <mat-option *ngFor="let option of filteredOptions | async" [value]="option.phoneNumber">
    {{ option.name }} ({{ option.phoneNumber | phoneNumberFormatter }})
  </mat-option>
</mat-autocomplete>
